/* eslint-disable */
import React from 'react'
import { Card } from 'react-bootstrap';
import { Divider } from 'primereact/divider';
import { useNavigate } from 'react-router-dom';

const SalesDashboardTile = (props) => {

  const showDetails = props?.showDetails ?? true;
  const navigate = useNavigate();

  // Generate a lighter shade for the icon background gradient
  const lightenColor = (color, percent) => {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    return "#" + (0x1000000 +
      (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)
    ).toString(16).slice(1);
  };

  const iconGradient = `linear-gradient(135deg, ${props.iconBackColor} 0%, ${lightenColor(props.iconBackColor || '#3b82f6', 20)} 100%)`;

  return (
    <Card style={{
      borderRadius: '12px',
      border: 'none',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      overflow: 'hidden'
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
      }}
    >
      <div className="salesCardContent" style={{ padding: '16px', height: 'auto', marginTop: 0 }}>
        <div className='row' style={{ marginBottom: "0", alignItems: 'center' }}>
          <div className='col-3' style={{ position: 'relative' }}>
            <div style={{
              background: iconGradient,
              width: '56px',
              height: '56px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 4px 12px ${props.iconBackColor}40`
            }}>
              <i className={`fa-sharp fa-solid fa-${props.icon}`} style={{
                fontSize: '22px',
                color: '#ffffff',
                ...props?.iconStyle
              }}></i>
            </div>
          </div>
          <div className='col-9 textAndCount' style={{ marginTop: 0, marginLeft: 0 }}>
            <span className="salesDashboard_text" style={{
              color: '#64748b',
              fontSize: '12px',
              fontWeight: '500',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>{props.status}</span><br></br>
            <span className="salesDashboard_Count" style={{
              color: '#1e293b',
              fontSize: '28px',
              fontWeight: '700',
              lineHeight: '1.2'
            }}>
              {String(props.count).includes('/') ? (
                <>
                  {String(props.count).split('/')[0]}/
                  <span style={{ fontSize: '17px', display: 'inline-block', marginTop: '10px' }}>
                    {String(props.count).split('/')[1]}
                  </span>
                </>
              ) : (
                props.count
              )}
            </span>
          </div>
        </div>
        {showDetails && <>
          <Divider className="col-12" layout="horizontal" style={{ margin: '12px 0 8px 0' }} />
          <div className='row' style={{ marginTop: "0" }} onClick={ props.route ? (e) => { e.preventDefault(); navigate(props?.route ?? '#', { state: props?.filter }) } : () => { }}>
            <div className='col-9'>
              <span style={{
                color: '#64748b',
                fontSize: '13px',
                fontWeight: '500'
              }}>{props.description}</span>
            </div>
            <div className='col-3' style={{ textAlign: 'right' }}>
              <div style={{
                background: iconGradient,
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 2px 6px ${props.iconBackColor}40`,
                transition: 'transform 0.2s ease'
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <i className="fa fa-arrow-right" style={{
                  color: '#ffffff',
                  fontSize: '12px'
                }}></i>
              </div>
            </div>
          </div>
        </>}
      </div>
    </Card>
  )
}

export default SalesDashboardTile